// extracted by mini-css-extract-plugin
module.exports = {"uid":"ue0d800c6"};